module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "trailer"
    }
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 csp-text-center"
  }, [_c('span', {
    staticClass: "csp-trailer-text"
  }, [_vm._v("\n      © " + _vm._s(_vm.copyrightYear) + " "), _c('a', {
    staticClass: "csp-router-link-text",
    attrs: {
      "href": _vm.website
    }
  }, [_vm._v(_vm._s(_vm.company))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.phonelink
    }
  }, [_vm._v(_vm._s(_vm._f("phone")(_vm.companyPhoneNumber)))]), _vm._v(" "), (_vm.socialIcons) ? _c('ul', {
    staticClass: "social"
  }, _vm._l((_vm.socialLinks), function(object, name) {
    return _c('li', [_c('social-icon', {
      attrs: {
        "object": object,
        "name": name
      }
    })], 1)
  })) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-569230e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trailer.vue
// module id = 858
// module chunks = 2